import { useLocale } from "@/context/LanguageContext";

export interface SuppressibleRow {
  label: string;
  count?: number | null;
  suppressed: boolean;
}

/**
 * Accessible companion table for a chart. Suppressed cells render as "<5"
 * (k-anonymity) rather than 0, so the chart's gaps/empty bars have a
 * screen-reader-friendly equivalent.
 */
export function SuppressibleTable({
  rows,
  labelHeader,
}: {
  rows: SuppressibleRow[];
  labelHeader: string;
}) {
  const { t } = useLocale();
  return (
    <table className="mt-4 w-full text-sm">
      <thead>
        <tr className="border-b border-border text-left text-xs uppercase tracking-wide text-muted-foreground">
          <th className="py-2 pr-4 font-medium">{labelHeader}</th>
          <th className="py-2 text-right font-medium">{t("analytics.countHeader")}</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.label} className="border-b border-border/60 last:border-0">
            <td className="py-2 pr-4 text-foreground">{row.label}</td>
            <td className="py-2 text-right tabular-nums text-foreground">
              {row.suppressed ? (
                <span className="text-muted-foreground" title={t("analytics.suppressionNote")}>
                  {t("analytics.suppressed")}
                </span>
              ) : (
                (row.count ?? 0).toLocaleString()
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
